import { MpfsShare } from '@schema';
import {
  FILE_STORAGE_SHARES_STATUS_ICON_MAP,
  FILE_STORAGE_SHARES_STATUS_TEXT
} from '@/common/constants/fileStorage.constants';

const mapper = (share: MpfsShare) => ({
  ...share,
  statusIcon: FILE_STORAGE_SHARES_STATUS_ICON_MAP[share.status],
  statusText: FILE_STORAGE_SHARES_STATUS_TEXT[share.status],
});

export type FileStorageShares = ReturnType<typeof mapper>;

export default mapper;
